import { useSelector } from "react-redux";
import { Redirect, useParams } from "react-router-dom";

import EditListingPage from "../EditListingPage";

const EditListingProtectedRoute = () => {
    const currentUser = useSelector((state) => state.user.currentUser);
    const params = useParams()
    const userAddress = currentUser && !!currentUser?.attributes?.profile?.protectedData?.ResidentialAddress;

    if (userAddress) {
        return (
            <EditListingPage params={params} />
        )
    } else {
        return <Redirect to='/' />
    }


}

export default EditListingProtectedRoute
